var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 20.4H3.2C1.6536 20.4 0.4 19.1464 0.4 17.6V3.2C0.4 1.6536 1.6536 0.4 3.2 0.4H9.10847C9.83345 0.4 10.5302 0.6812 11.052 1.18444L14.7436 4.74413C15.2908 5.27185 15.6 5.99943 15.6 6.75969V10.4V17.6C15.6 19.1464 14.3464 20.4 12.8 20.4Z",
    fill: "#250F7F",
    stroke: "#250F7F",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6862 14.2614H2.8343V18H5.059V17.2566H3.6862V14.2614ZM6.44693 18V14.2614H5.59503V18H6.44693ZM9.28698 16.383L8.09324 14.2614H7.31188V18H8.16378V15.8513L9.39007 18H10.1389V14.2614H9.28698V16.383ZM12.5899 16.1117L13.8325 14.2614H12.8178L11.8465 15.7699V14.2614H10.9946V18H11.8465V16.535L12.948 18H14.0387L12.5899 16.1117Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLink);
export default __webpack_public_path__ + "static/media/FileLink.0c2670b0.svg";
export { ForwardRef as ReactComponent };